<div content>
  <app-hello-there></app-hello-there>
  <sh-text size="super-header">Search</sh-text>
  <sh-search
    (focus)="routeService.openSearch(true, true)"
    [label]="'search.callToAction' | translate"
  ></sh-search>
  <div spacer></div>
  <sh-tabs role="tablist">
    <sh-tab-item
      label="Useful Apps"
      [active]="tab === 1"
      (click)="tab = 1"
      role="tab"
    ></sh-tab-item>
    <sh-tab-item
      label="MI SPECT"
      [active]="tab === 2"
      (click)="tab = 2"
      role="tab"
    ></sh-tab-item>
    <sh-tab-item
      label="MI PET"
      [active]="tab === 3"
      (click)="tab = 3"
      role="tab"
    ></sh-tab-item>
    <sh-tab-item
      label="MR"
      [active]="tab === 4"
      (click)="tab = 4"
      role="tab"
    ></sh-tab-item>
  </sh-tabs>
  <div tabContents>
    <app-useful-applications
      *ngIf="tab === 1"
      [allowSystemContext]="false"
      [menuMode]="false"
      [showTitle]="false"
      [displayType]="'flex'"
      [flexWrapType]="'wrap'"
      [showInfoIcon]="false"
    ></app-useful-applications>
    <app-mi-applications
      [landingPageMode]="true"
      *ngIf="tab === 2"
      [modalityId]="12"
    ></app-mi-applications>
    <app-mi-applications
      [landingPageMode]="true"
      *ngIf="tab === 3"
      [modalityId]="10"
    ></app-mi-applications>
    <div *ngIf="tab === 4">
      <a href="https://sdtb.siemens-healthineers.com/mrq" target="_blank">
        <sh-tool label="MRQ Dashboard" icon="trending-graph"></sh-tool>
      </a>
    </div>
  </div>
</div>
<div img>
  <div logo></div>
</div>
